// eslint-disable-next-line no-magic-numbers
export const MAX_VEHICLES = 5

export enum CompareEventType {
    DRIVING_COMPARE_ADD_INIT = 'car-comparison-add-init',
    DRIVING_COMPARE_ADD_SUCCESS = 'car-comparison-add-success',
    DRIVING_COMPARE_ADD_FAILED = 'car-comparison-add-failed',
    DRIVING_COMPARE_ADD_OUT_OF_RANGE = 'car-comparison-add-out-of-range',
    DRIVING_COMPARE_REMOVE = 'car-comparison-remove-compare'
}
